export const resetPasswordEN = {
  main: 'Update your new password'
}
